import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { TelehealthConsentHistoryService } from 'src/app/services/repositories/telehealth-consent-history.service';
import { TelehealthConsentHistoryRequest } from 'src/app/models/requests/telehealth-consent-history-request.model';
import { EXAM_TYPES } from 'src/app/helpers/examTypes.helper';

@Component({
    selector: 'app-telehealth-consent',
    templateUrl: './telehealth-consent.component.html',
    styleUrls: ['./telehealth-consent.component.scss'],
    standalone: false
})
export class TelehealthConsentComponent implements OnInit {
  public formText: string = '';
  public examId: number = 0;
  public examType: string = '';
  public readonly EXAM_TYPES = EXAM_TYPES;

  constructor(private _authService: AuthenticationService,
    private _loaderService: NgxUiLoaderService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _telehealthHistory: TelehealthConsentHistoryService,
    private _notificationService: ToastrService) {
  }

  ngOnInit(): void {
    this._route.queryParams
      .subscribe(params => {
        const examId = params['examId'];
        const examType = params['examType'];
        if (examId) {
          this.examId = +examId;
        }
        if (examType) {
          this.examType = examType;
        }
      });
  }

  createTelehealth(event: string): TelehealthConsentHistoryRequest | null {
    let userId = this._authService.getUserId();
    if (userId) {
      return {
        examId: this.examId,
        userId: userId,
        base64: event,
      };
    } else {
      this._loaderService.stop();
      return null;
    }

  }

  setSignature(event: string) {
    this._loaderService.start();
    const form = this.createTelehealth(event);
    let contents: { name: string, value: string | Blob }[] = [];
    if (form) {
      contents = [
        {
          name: 'ExamId',
          value: form.examId.toString()
        },
        {
          name: 'UserId',
          value: form.userId.toString()
        },
        {
          name: 'base64',
          value: form.base64
        }
      ];
    }

    const mp = this.getAgreementMultipartFormData(contents);
    this._telehealthHistory.getByExamId(this.examId)
      .subscribe((tele) => {
        if (tele !== null) {
          this._loaderService.stop();
          this._router.navigate(['/sign-out/yes-tele'])
        } else {
          this._telehealthHistory.create(mp)
          .subscribe((data) => {
            this._loaderService.stop();
            this._router.navigate(['/sign-out/no-tele'])
          }, err => {
            this._notificationService.error(err.error.message, 'Telehealth Consent History');
            this._loaderService.stop();
          });
        }
      }, err => {
        this._notificationService.error(err.error.message, 'Telehealth Consent History');
        this._loaderService.stop();
      });
  }

  private getAgreementMultipartFormData(contents: { name: string, value: string | Blob }[]): FormData {
    const fd = new FormData();
    for (const content of contents) {
      fd.append(content.name, content.value);
    }
    return fd;
  }

}


